// Types
import type { IntegrationApplication } from "./integration.types";

// Store
import { useSessionStore } from "@store";

// Services
import { useIntegrationsService } from "@services";

// Utils
import { ok } from "neverthrow";

export const useIntegrationsApp = (): IntegrationApplication => {
  const integrationsService = useIntegrationsService();
  const sessionStore = useSessionStore();

  const integrationApp: IntegrationApplication = {
    async list() {
      const res = await integrationsService.list({
        lang: sessionStore.session?.lang,
      });

      if (res.isErr()) return ok([]);

      return ok(res.value);
    },
    async getIntegrations() {
      const res = await integrationsService.getIntegrations();

      if (res.isErr()) return ok([]);

      return ok(res.value.map((s) => s.name));
    },
  };

  return integrationApp;
};
